import React from 'react'

import pkg from '../../../../package.json'
const { version } = pkg

const Footer = () => <footer>v.{version}</footer>

export default Footer
